import React from "react";
import Navbar from "../connected/Navbar";
import Footer from "../connected/Footer";
import SignupHeroSection from "../sections/signupSection/SignupHeroSection";
import PageHeader from "../primitive/PageHeader";

const Signup = () => {
  return (
    <div>
      <PageHeader browserTitle="Get Started | Smartcomply Seequre" />
      <Navbar />
      <SignupHeroSection />
      <Footer />
    </div>
  );
};

export default Signup;
